import React from 'react'
import { useTranslation } from 'react-i18next'
import DropDown from '../../../../../component/formFields/DropDown'
import { serviceCatgoryLookup } from '../../../../../api/endpoints/ServiceCategory'
import SectionCard from '../shared/SectionCard'
import './style.css'

const EditSpecialties = ({ formHandler, providerInfo }) => {
    const { t } = useTranslation()

    return (
        <SectionCard 
            title={t("specialties")} 
            icon="mdi:medical-bag"
            className="edit-specialties"
        >
            <div className="edit-form-grid">
                <div className="form-field full-width">
                    <DropDown 
                        label={"serviceCategories"} 
                        endPoint={serviceCatgoryLookup} 
                        defaultValue={providerInfo?.serviceCategories} 
                        formHandler={formHandler}
                        isDisabled
                    />
                    <p className="helper-text">{t("specialties-locked-message")}</p>
                </div>
            </div>
        </SectionCard>
    )
}

export default EditSpecialties

